import defaultShopState from './ShopProvider';

const shopReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SHOP':
      localStorage.setItem("shop", JSON.stringify(action.payload));
      return { shop: action.payload, delivery_data: state.delivery_data };

    case 'SET_DELIVERY_DATA':
      localStorage.setItem("delivery_data", JSON.stringify(action.payload));
      return { shop: state.shop, delivery_data: action.payload };

    default:
      return defaultShopState;
  }
};

export default shopReducer;
